import { HtmlArticle } from '@doist/marketist'

import css from './MainContent.module.css'

export type MainContentProps = {
    content: string
}

export function MainContent({ content }: MainContentProps): JSX.Element {
    return <HtmlArticle className={css.mainContent} theme="doist" html={content} />
}
